/**
 * Order price summary — B2C Inc. VAT: coupon off displayed price, then extract VAT.
 */

function round2(n) {
  return Math.round(Number(n) * 100) / 100;
}

function getPaidItems(order) {
  return (order?.items || []).filter(
    (i) => !i.isPromotionalGift && (Number(i.lineTotal) || 0) > 0,
  );
}

export function getOrderPriceSummary(order) {
  const pricing = order?.pricing || {};
  const items = getPaidItems(order);
  const goods = Number(pricing.subtotal) || 0;
  const coupon = Number(pricing.couponDiscount) || 0;
  const discountedGoods = round2(goods - coupon);
  const vatAmount = Number(pricing.vatAmount || order?.vat) || 0;
  const vatRate = Number(pricing.vatRate) || 0;

  const hasInclusive = items.some((i) => i.vatMode === 'inclusive');
  const hasExclusive = items.some((i) => !i.vatMode || i.vatMode === 'exclusive');
  const hasZero = items.some((i) => i.vatMode === 'zero');
  const isAllInclusive = hasInclusive && !hasExclusive && !hasZero;

  let inclusiveVat = round2(
    items
      .filter((i) => i.vatMode === 'inclusive')
      .reduce((s, i) => s + (Number(i.lineVatAmount) || 0), 0),
  );
  if (isAllInclusive && inclusiveVat <= 0 && vatAmount > 0) {
    inclusiveVat = vatAmount;
  }

  let taxableAmount;
  if (pricing.netSubtotal != null && !Number.isNaN(Number(pricing.netSubtotal))) {
    taxableAmount = round2(pricing.netSubtotal);
  } else {
    taxableAmount = round2(discountedGoods - inclusiveVat);
  }

  const couponCode = order?.appliedCouponCode ? ` (${order.appliedCouponCode})` : '';
  const summaryRows = [];

  if (isAllInclusive) {
    summaryRows.push({ label: 'Subtotal', value: goods });
    if (coupon > 0) {
      summaryRows.push({
        label: `Discount${couponCode}`,
        value: -coupon,
        isDiscount: true,
      });
    }
    if (vatAmount > 0) {
      summaryRows.push({
        label: 'Includes VAT',
        value: vatAmount,
        isInformational: true,
      });
    }
  } else {
    const preCouponEx =
      coupon > 0 && hasExclusive && !hasInclusive
        ? round2(taxableAmount + coupon)
        : taxableAmount;
    summaryRows.push({ label: 'Subtotal', value: preCouponEx });
    if (coupon > 0) {
      summaryRows.push({
        label: `Discount${couponCode}`,
        value: -coupon,
        isDiscount: true,
      });
    }
    if (vatAmount > 0) {
      const vatLabel = vatRate ? `VAT (${vatRate}%)` : 'VAT';
      summaryRows.push({ label: vatLabel, value: vatAmount });
    }
  }

  const vatLabel = isAllInclusive && vatAmount > 0 ? 'Includes VAT' : vatRate ? `VAT (${vatRate}%)` : 'VAT';

  return {
    summaryRows,
    isAllInclusive,
    priceIncVat: goods,
    goodsTotalPaid: discountedGoods,
    taxableAmount,
    couponDiscount: coupon,
    subtotal: isAllInclusive ? (coupon > 0 ? discountedGoods : goods) : taxableAmount,
    vatAmount,
    vatRate,
    vatLabel,
    showVat: vatAmount > 0,
  };
}
